import Vue from 'vue'
import Router from 'vue-router' 

Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: "home",
      component: () => import('../views/Home.vue')
    }, 
    {
      path: '/core',
      name: "core",
      component: () => import('../views/CoreTechnology.vue')
      
    }, 
    {
      path: '/yw',
      name: "yw",
      component: () => import('../views/YwService.vue')
      
    }, 
    {
      path: '/safe',
      name: "safe",
      component: () => import('../views/SafeService.vue')
      
    }, 
    {
      path: '/qc',
      name: "qc",
      component: () => import('../views/DeviceQc.vue')
      
    }, 
    {
      path: '/scene',
      name: "scene",
      component: () => import('../views/Scene.vue')
      
    }, 
    {
      path: '/city',
      name: "city",
      component: () => import('../views/SceneCity.vue')
      
    }, 
    {
      path: '/government',
      name: "government",
      component: () => import('../views/SceneGovernment.vue') 
    }, 
    {
      path: '/school',
      name: "school",
      component: () => import('../views/SceneSchool.vue') 
    }, 
    {
      path: '/army',
      name: "army",
      component: () => import('../views/SceneArmy.vue') 
    }, 
    {
      path: '/about',
      name: "about",
      component: () => import('../views/About.vue')
      
    }, 
    {
      path: '/company',
      name: "company",
      component: () => import('../views/Company.vue')
      
    }, 
    {
      path: '/publish',
      name: "publish",
      component: () => import('../views/Publish.vue')
      
    }, 
    {
      path: '/brand',
      name: "brand",
      component: () => import('../views/BrandStory.vue') 
    }, 
    {
      path: '/terminal',
      name: "terminal",
      component: () => import('../views/Terminal.vue')
    },
    {
      path: '/hardware',
      name: "hardware",
      component: () => import('../views/Hardware.vue')
    },
    {
      path: '/starFire',
      name: "starFire",
      component: () => import('../views/StarFire.vue')
      
    }, 
    {
      path: '/bigthing',
      name: "bigthing",
      component: () => import('../views/BigThing.vue')
      
    },
    {
      path: '/bigthingdetail',
      name: "bigthingdetail",
      component: () => import('../views/BigThingDe.vue')
    },
    {
      path: '/joinUs',
      name: "joinUs",
      component: () => import('../views/JoinUs.vue')
      
    }
  ],
  scrollBehavior(to, from,savedPosition) {
    return {
      x: 0,
      y: 0
    }
  } 
})



// WEBPACK FOOTER //
// ./src/router/index.js